module.exports = __webpack_public_path__ + "img/stamp0.7971de0c.jpg";